<template>
  <div ref="charts" style="width:100%;height:500px"></div>
</template>
<script>
  import echarts from "echarts";
  import { onMounted, ref } from "vue";
  export default {
    name: "echartsBar",
    setup() {
      const charts = ref();
      onMounted(() => {
        const chart = charts.value;
        var labelOption = {
            show: true,
            position: 'top',
            distance: 20,
            align: 'center',
            verticalAlign: 'middle',
            rotate: 0,
            formatter: '{name|{a}}：{c} ',
            fontSize: 16,
            color:"#999",
            rich: {
                name: {color: "#999"}
            }
        };
        if (chart) {
          var myChart = echarts.init(chart);
          const option = {
            color:['#437BB7','#1E855C'],
            tooltip: {
              trigger: 'axis',
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            legend: {
              data: ["新增用户"],
            },
            xAxis: {
              type: "category",
              data: [
                {
                  value: '红包',
                  textStyle: {
                      fontSize: 14,
                      color: '#999'
                  }
                },
                {
                  value: '积分',
                  textStyle: {
                      fontSize: 14,
                      color: '#999'
                  }
                },
                {
                  value: '卡券',
                  textStyle: {
                      fontSize: 14,
                      color: '#999'
                  }
                }],
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                name: '发放量',
                type: 'bar',
                barGap: '20%',barWidth: '20%',
                label: labelOption,
                data: [320, 332, 301]
              },
              {
                name: '消耗量',
                type: 'bar',barWidth: '20%',
                label: labelOption,
                emphasis: {
                  focus: 'series'
                },
                data: [220, 182, 191]
              },
            ],
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
      return {
        charts,
      };
    },
  };
</script>